







import {Component, Prop, Vue} from 'vue-property-decorator';
import {MathTask} from "@/api/api.clients";


@Component({
    components: {}
})

export default class LearnMathTask extends Vue {
    @Prop(Object)
    item: MathTask | null = null;

    @Prop(String)
    value: string | null = null;

    async mounted() {

    }


    private clearSolution() {
        this.$emit("clearSolution");
    }
}
